/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdAlertViewListRequest {
    getFixupPrototypeFunction() { return ThresholdAlertViewListRequest.fixupPrototype; }

    static newInstance(model: Partial<ThresholdAlertViewListRequest>): ThresholdAlertViewListRequest {
        let obj = Object.assign(new ThresholdAlertViewListRequest(), model);
        ThresholdAlertViewListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdAlertViewListRequest>): ThresholdAlertViewListRequest {
        if (!model) return null;
        return ThresholdAlertViewListRequest.newInstance(<ThresholdAlertViewListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdAlertViewListRequest) {
        if (!obj) return;

        models.ThresholdAlertViewListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdAlertViewListRequest): boolean {
        Object.setPrototypeOf(obj, ThresholdAlertViewListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * budget uri
     */
    budget_uri: string;

    /**
     * tenant ID
     */
    project_id: string;

    /**
     * dimension ID
     */
    dimension_id: Array<string>;

}
